//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { loginUser } from "../login/thunk";

// action
import { apiErrorChange, resetRegisterFlagChange } from "./reducer";

// initialize relavant method of both Auth
let fireBaseBackend = getFirebaseBackend();

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const registerUser = async (user, dispatch) => {
  try {
    fireBaseBackend = getFirebaseBackend();
    const body = JSON.stringify({
      email: user.email,
      password: user.password,
      role: user.role,
      inviteCode: user.inviteCode,
      role: user.role
    });

    const headers = {
      "Content-Type": "application/json",
    };

    const apiResponse = await fetch(`${API_URL}/dashboard/auth/register`, {
      method: "POST",
      headers: headers,
      body: body,
    });

    if (!apiResponse.ok) {
      const errorResponse = await apiResponse.json();

      throw new Error(errorResponse.error);
    }

    const responseData = await apiResponse.json();

    // const accessToken = responseData.accessToken;

    await fireBaseBackend.loginUser(user.email, user.password);
    loginUser(user, dispatch);

    return responseData;
  } catch (error) {
    console.error(error.message);
    throw new Error(error.message);
    // dispatch(registerUserFailed(error.message));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const apiError = () => {
  try {
    const response = apiErrorChange();
    return response;
  } catch (error) {
    return error;
  }
};
